
import { formatPrice } from '../../utils/utils'

const axios = require('axios')

export default {
  name: 'checkout-form',
  props: {
    clientInfo: Object,
    createCustomer: Boolean,
    createSubscription: Boolean,
    updatePaymentMethod: Boolean,
    custId: String,
    product: Object,
    isLoading: Boolean
  },
  data() {
    return {
      clientId: localStorage.getItem('clientId'),
      btnDisabled: true,
      cardErrorMsg: '',
      token: null,
      card: null,
      customer: null,
      cardname: '',
      couponCode: null,
      couponObj: null,
      freeTrialDays: null,
      loadingMessage: '',
      isCouponLoading: false,
      showCheckoutForm: true
    }
  },
  mounted() {
    const legacyTrial = this.$route.query['free-trial']
    if (legacyTrial) {
      this.freeTrialDays = legacyTrial
      this.$emit('trial-applied', legacyTrial)
    }

    const promoFromUrl = this.$route.query.promo
    if (promoFromUrl) {
      this.couponCode = promoFromUrl
      this.$nextTick(() => {
        this.applyCoupn(null)
      })
    }

    this.buildStripeForm()
  },
  methods: {
    calculatePerccentage() {
      const perc = this.couponObj.coupon.percent_off / 100

      return this.product.price.unit_amount * perc
    },
    submitStripeForm() {
      if (this.updatePaymentMethod) {
        this.$emit('loading', true)
        this.updateDefaultPaymentMethod()
      } else {
        this.payWithCard()
      }
    },
    async updateDefaultPaymentMethod() {
      try {
        const token = await this.$stripe.createToken(this.card.number)
        await axios.post(`${process.env.API_URL}/updatePaymentMethod`, {
          cus_id: this.custId,
          token,
          userId: this.clientId
        })
        this.$snotify.success('Your default payment method has been updated!')
      } catch (error) {
        console.log(`updateDefaultPaymentMethod: ${error}`)
      }
      this.$emit('paymentMethodUpdated')
    },
    formatPrice(price) {
      return formatPrice(price)
    },
    deleteCustomer() {
      axios
        .post(`${process.env.API_URL}/deleteStripeCustomer`, {
          cus_id: this.custId ? this.custId : this.customer.id
        })
        .then(() => {
          this.$emit('loading', false)
        })
        .catch((error) => {
          this.$emit('loading', false)
          this.$snotify.error(error)
        })
    },

    applyCoupn(e) {
      if (e) {
        e.preventDefault()
      }
      if (!this.couponCode) {
        return
      }
      this.isCouponLoading = true
      this.$emit('loading', true)
      axios
        .post(`${process.env.API_URL}/retrieveCoupon`, {
          couponCode: this.couponCode,
          product: this.product,
          customerId: this.custId ? this.custId : this.customer?.id,
          customerEmail: this.clientInfo.email
        })
        .then((scss) => {
          if (scss?.data.data.length && scss?.data.data[0].active) {
            this.couponObj = scss?.data.data[0]
            const trialDays =
              this.couponObj.trialDays ||
              this.couponObj.metadata?.trial_days ||
              this.couponObj.coupon?.metadata?.trial_days

            if (trialDays) {
              this.freeTrialDays = trialDays
              this.$emit('trial-applied', trialDays)
              this.$snotify.success(`${trialDays}-day free trial applied.`)
            } else {
              this.$snotify.success('Coupon applied successfully.')
            }

            // hide checkout form if total price is 0
            if (this.calculateTotalPrice() === 0 && this.product.price.type !== 'recurring') {
              this.showCheckoutForm = false
            }
          } else {
            this.$snotify.error('Coupon code not found!')
          }
          this.$emit('loading', false)
          this.isCouponLoading = false
        })
        .catch((error) => {
          const errMsg = error.response.data.error
          this.$emit('loading', false)
          this.isCouponLoading = false
          if (errMsg) {
            this.$snotify.error(errMsg)
          } else {
            this.$snotify.error(error)
          }
        })
    },

    async payWithCard() {
      // allow purchase without card if total price is 0 due to discount or free trial
      if (this.calculateTotalPrice() === 0 && this.product.price.type !== 'recurring') {
        this.purchaseProduct()
        return
      }
      this.$stripe
        .createPaymentMethod({
          type: 'card',
          card: this.card.number, // NumberElement
          billing_details: {
            name: this.cardname,
            email: this.clientInfo.email
          }
        })
        .then((result) => {
          if (result.error) {
            // Delete customer if is register page only so won't delete it on renewal
            if (this.$router.history.current.name === 'register') {
              this.deleteCustomer()
            }
            this.$snotify.error(result.error.message)
            this.$emit('loading', false)
          } else if (this.product.price.type === 'recurring') {
            this.createClientSubscription(result)
          } else {
            this.purchaseProduct(result)
          }

          this.$emit('turnOffSub', false)
        })
        .catch((error) => {
          this.$emit('loading', false)
          // Delete customer if is register page only so won't delete it on renewal
          if (this.$router.history.current.name === 'register') {
            this.deleteCustomer()
          }
          this.$snotify.error(error)
        })
    },

    createStripeCustomer() {
      axios
        .post(`${process.env.API_URL}/createStripeClient`, this.clientInfo)
        .then((customer) => {
          this.customer = customer.data
          if (this.showCheckoutForm) {
            this.payWithCard()
          } else {
            // If no card is needed (e.g., free trial or total price is 0), proceed with purchase
            this.purchaseProduct()
          }
        })
        .catch((error) => {
          this.$emit('loading', false)
          this.$emit('turnOffSub', false)
          this.$snotify.error(error)
        })
    },

    // calculate total price after applying coupon
    calculateTotalPrice() {
      if (this.couponObj && this.couponObj.coupon.amount_off) {
        return this.product.price.unit_amount - this.couponObj.coupon.amount_off
      }

      if (this.couponObj && this.couponObj.coupon.percent_off) {
        const perc = this.couponObj.coupon.percent_off / 100
        return this.product.price.unit_amount - (this.product.price.unit_amount * perc)
      }

      return this.product.price.unit_amount
    },

    async purchaseProduct(paymentMethod = null) {
      const token = paymentMethod ? await this.$stripe.createToken(this.card.number) : null
      const customerId = this.custId ? this.custId : this.customer.id
      axios
        .post(`${process.env.API_URL}/productPurchase`, {
          customerId,
          price: this.product.price,
          token,
          userId: this.clientId ? this.clientId : null,
          coupon: this.couponObj,
          quantity: this.sessions.length ? this.sessions.length : 1,
          name: this.cardname
        })
        .then(async (res) => {
          // IF PAYMENT SUCCESS
          if (res.data.paid && res.data.status === 'paid') {
            this.$emit('paymentProcess', null, paymentMethod, res.data, customerId)
            this.$fireAnalytics.logEvent('product_purchase')
          }
        })
        .catch((error) => {
          this.$emit('loading', false)
          // Delete customer if is register page only so won't delete it on renewal
          if (this.$router.history.current.name === 'register') {
            this.deleteCustomer()
          }

          this.$snotify.error(error.response.data.raw.message)
        })
    },

    async createClientSubscription(paymentMethod) {
      const token = await this.$stripe.createToken(this.card.number)
      axios
        .post(`${process.env.API_URL}/createSubscription`, {
          customerId: this.custId ? this.custId : this.customer.id,
          paymentMethodId: paymentMethod.paymentMethod.id,
          priceId: this.product.price.id,
          token,
          userId: this.clientId ? this.clientId : null,
          coupon: this.couponObj,
          freeTrialDays:
            this.couponObj?.trialDays ||
            this.couponObj?.metadata?.trial_days
              ? null
              : this.freeTrialDays || null
        })
        .then((subscr) => {
          if (subscr.data.status === 'active' || subscr.data.status === 'trialing') {
            this.$emit('paymentProcess', subscr, paymentMethod)
            this.$fireAnalytics.logEvent('app_subscribe')
          } else {
            // Delete customer if is register page only so won't delete it on renewal
            // eslint-disable-next-line no-lonely-if
            if (this.$router.history.current.name === 'register') {
              this.deleteCustomer()
            }
          }
        })
        .catch((error) => {
          this.$emit('loading', false)
          this.$emit('turnOffSub', false)
          // Delete customer if is register page only so won't delete it on renewal
          if (this.$router.history.current.name === 'register') {
            this.deleteCustomer()
          }
          this.$snotify.error(error.response.data)
        })
    },

    buildStripeForm() {
      const elements = this.$stripe.elements()

      const elementStyles = {
        base: {
          color: '#fff',
          fontSize: '17px',
          fontSmoothing: 'antialiased',
          iconColor: '#9ae17b',

          ':focus': {
            color: '#ffffff'
          },

          '::placeholder': {
            color: '#9BACC8'
          },

          ':focus::placeholder': {
            color: '#9ae17b'
          }
        },
        invalid: {
          color: '#fff',
          ':focus': {
            color: '#FA755A'
          },
          '::placeholder': {
            color: '#FFCCA5'
          }
        }
      }

      const elementClasses = {
        focus: 'focus',
        empty: 'empty',
        invalid: 'invalid'
      }

      const cardNumber = elements.create('cardNumber', {
        style: elementStyles,
        showIcon: true,
        classes: elementClasses,
        placeholder: 'Card number'
      })
      cardNumber.mount('#card-number')

      const cardExpiry = elements.create('cardExpiry', {
        style: elementStyles,
        classes: elementClasses
      })
      cardExpiry.mount('#card-expiry')

      const cardCvc = elements.create('cardCvc', {
        style: elementStyles,
        classes: elementClasses
      })
      cardCvc.mount('#card-cvc')

      this.card = {
        number: cardNumber,
        exp: cardExpiry,
        cvc: cardCvc
      }
    }
  },
  watch: {
    createCustomer(nV) {
      if (nV) {
        this.createStripeCustomer()
      }
    },
    createSubscription(nV) {
      if (nV) {
        this.payWithCard()
      }
    },
    isLoading(nV) {
      if (nV) {
        if (this.isCouponLoading) {
          this.loadingMessage = 'Applying your coupon — hang tight!'
        }
        if (!this.isCouponLoading && this.showCheckoutForm) {
          this.loadingMessage = 'Processing your payment — this might take a few moments.'
        }
        if (!this.isCouponLoading && !this.showCheckoutForm) {
          this.loadingMessage = 'Preparing your workout program - hang tight!'
        }
      }
    }
  },
  computed: {
    sessions() {
      return this.$store.state.selectedSessions
    },
    hasDiscountCoupon() {
      if (!this.couponObj?.coupon) return false
      const { amount_off, percent_off } = this.couponObj.coupon
      return !!(amount_off || (percent_off && percent_off > 1))
    }
  }
}
